<template>
  <div
    v-if="items.length"
    class="border border-secondary rounded-lg bg-primary py-0.5"
  >
    <Component
      v-for="(item, index) in items"
      :key="index"
      :is="item"
      :divider="last(items) !== item"
    />
  </div>
</template>

<script setup>
import { computed, useSlots } from "vue";
import { last } from "lodash";

const slots = useSlots();

const items = computed(() =>
  slots.default ? slots.default().filter((node) => node.type) : []
);
</script>
